import { render, staticRenderFns } from "./ReportReference.vue?vue&type=template&id=58048c02"
import script from "./ReportReference.vue?vue&type=script&lang=js"
export * from "./ReportReference.vue?vue&type=script&lang=js"
import style0 from "./ReportReference.vue?vue&type=style&index=0&id=58048c02&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports